import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Container, Grid, Typography } from '@mui/material'
import { useHistory, useParams } from 'react-router-dom'
import GoBackButton from '../../../../components/Buttons/GoBackButton.jsx'
import OfoqThemeBtn from '../../../../components/Buttons/OfoqThemeBtn.jsx'
import { customerAdminSelectUsers } from '../../../../redux/features/users/customerAdmin/customerAdminSlice'
import {
  customerAdminCreateUsers,
  customerAdminEditUser,
  retrieveCustomerAdminUserByID,
  customerAdminUpdateSelectedUser,
  customerAdminResetAlertHandler,
} from '../../../../redux/features/users/customerAdmin/customerAdminThunk'
import retrieveTitles from '../../../../redux/features/titles/titlesThunk'
import retrieveDepartments from '../../../../redux/features/departments/departmentsThunk'
import UserStepOne from './UserSteps/UserStepOne.jsx'
import UserStepTwo from './UserSteps/UserStepTwo.jsx'
import OfoqIosSwitch from '../../../../components/Forms/OfoqIosSwitch.jsx'
import { retrieveEmployees } from '../../../../redux/features/employees/employeesThunk'
import ConfirmationModalContainer from '../../../../components/Modals/ConfirmationModalContainer.jsx'
import FinishModalContainer from '../../../../components/Modals/FinishModalContainer.jsx'
import { isNotEmpty } from '../../../../utils/helpers'
import { selectAuthUser } from '../../../../redux/features/userAuth/userAuthSlice'
import UseTranslation from '../../../../hooks/UseTranslation.jsx'
import { userActiveStatesList, userDeactivateStatesList } from '../../../../utils/modalDataContainer'
import LoaderWithErrorHandler from '../../../../components/PageHelpers/LoaderWithErrorHandler.jsx'

const Index = () => {
  const history = useHistory()
  const { id } = useParams()
  const dispatch = useDispatch()
  const { t } = UseTranslation()
  const users = useSelector(customerAdminSelectUsers)
  const { authorizedUser } = useSelector(selectAuthUser)
  const [activeStep, setActiveStep] = useState(1)
  const [validStepOne, setValidStepOne] = useState(false)
  const [validStepTwo, setValidStepTwo] = useState(true)
  const [activeUser, setActiveUser] = useState(users.updatedUser?.active || true)
  const [deactivateModalState, setDeactivateModalState] = useState(false)
  const [finishModalState, setFinishModalState] = useState(false)

  useEffect(() => {
    setActiveUser(users.updatedUser?.active)
    if (users.updatedUser?.customer_admin) {
      setValidStepTwo(false)
    } else if (isNotEmpty(users.updatedUser?.roles)) {
      setValidStepTwo(false)
    } else {
      setValidStepTwo(true)
    }
  }, [users.updatedUser])

  useEffect(() => {
    dispatch(retrieveTitles())
    if (authorizedUser?.user_integration_type === 'STANDALONE') {
      dispatch(retrieveDepartments({ queries: authorizedUser?.tenant_id }))
    } else {
      dispatch(retrieveEmployees({ queries: authorizedUser?.tenant_id }))
    }

    if (id) {
      dispatch(
        retrieveCustomerAdminUserByID({
          queries: {
            id,
          },
        }),
      )
    }
  }, [id])

  const stepHandler = (nextCheck) => {
    if (activeStep < 2) {
      setActiveStep(nextCheck ? activeStep + 1 : activeStep - 1)
    } else {
      setActiveStep(activeStep - 1)
    }
  }

  const confirmHandler = () => {
    const action = id
      ? customerAdminEditUser({ queries: users })
      : customerAdminCreateUsers({ queries: users });

    dispatch(action).then((response) => {
      if (response.meta.requestStatus === 'fulfilled') {
        history.goBack();
      }
    });
  };

  const cancelHandler = (cancel) => {
    dispatch(customerAdminUpdateSelectedUser({}))

    if (cancel) {
      history.goBack()
    }
  }

  const changeStatusHandler = () => {
    setDeactivateModalState(true)
  }

  const handelCloseModals = () => {
    setDeactivateModalState(false)
    setFinishModalState(false)
  }

  return (
    <>
      <Container maxWidth='xl'>
        <Grid container spacing={3}>
          <Grid item xs={12} sx={styles.goBackWrapper}>
            <GoBackButton label={t?.['Back to Users']} customBackLink='/home' andThisAction={cancelHandler} />
          </Grid>

          <Grid item xs={12} lg={12} sx={styles.usersWrapper}>
            <Box sx={styles.usersSection}>
              {id === undefined ? (
                <Typography variant='h6' sx={styles.usersTitle}>
                  {t?.['Add New Customer User']}
                </Typography>
              ) : (
                <Typography variant='h6' sx={styles.usersTitle}>
                {t?.['Edit Customer User']}
                  </Typography>
              )}
            </Box>

            <Box sx={styles.actionButtonsContainer}>
              {id && activeStep === 1 && (
                <Box sx={styles.activeBtnContainer}>
                  <Typography variant='p' sx={styles.inactive}>
                  {t?.Inactive}
                  </Typography>
                  <OfoqIosSwitch
                  defaultValue={activeUser}
                  onChangeHandler={changeStatusHandler} customStyle={styles.iosSwitch} />
                  <Typography variant='p' sx={styles.active}>
                  {t?.Active}
                  </Typography>
                </Box>
              )}
              <Box sx={styles.btnContainer}>
              {activeStep === 2 ? (
                <OfoqThemeBtn
                  onClick={() => stepHandler()}
                   name={t?.Back}
                  customStyle={styles.ButtonsContainer}
                  cancelStyle
                />
              ) : (
                <OfoqThemeBtn
                  onClick={() => cancelHandler(true)}
                   name={t?.Cancel}
                  customStyle={styles.ButtonsContainer}
                  cancelStyle
                />
              )}

              {activeStep === 2 && (
                <OfoqThemeBtn
                  onClick={() => confirmHandler()}
                  dimmed={validStepTwo}
                  disabled={validStepTwo}
                  name={t?.Finish}
                  customStyle={styles.ButtonsContainer}
                />
              )}

              {activeStep === 1 && (
                <OfoqThemeBtn
                  onClick={() => stepHandler(true)}
                  name={t?.Next}
                  dimmed={!validStepOne}
                  disabled={!validStepOne}
                  customStyle={styles.ButtonsContainer}
                />
              )}

              </Box>
              </Box>
            <br />
          </Grid>
        </Grid>

        <Grid container justify='space-between' alignItems='center'>
          <Grid item xs={6} lg={6}>
            <Typography variant='span' sx={styles.infoTabsTitle}>
              1.{t?.['Basic Information']}
            </Typography>
            <Box sx={styles.activeStep}></Box>
          </Grid>
          <Grid item xs={6} lg={6}>
            <Typography variant='span' sx={styles.infoTabsTitle}>
              2.{t?.['Role Information']}
            </Typography>
            {activeStep >= 2 ? (
              <Box sx={styles.activeStep}></Box>
            ) : (
              <Box sx={styles.step}></Box>
            )}
          </Grid>

        </Grid>
      </Container>

      <Container maxWidth='xl' sx={styles.dataContainer}>
        <Box sx={styles.activeStepBody}>
          {activeStep === 1 && <UserStepOne setValidStepOne={setValidStepOne} />}
          {activeStep === 2 && <UserStepTwo setValidStepTwo={setValidStepTwo} />}
        </Box>
      </Container>

      <ConfirmationModalContainer
        modalState={deactivateModalState}
        setModalState={setDeactivateModalState}
        setFinishModalState={setFinishModalState}
        confirmationData={activeUser ? userDeactivateStatesList : userActiveStatesList}
        confirmHandler={customerAdminUpdateSelectedUser}
        confirmHandlerQueries={{
          ...users.updatedUser,
          active: !activeUser,
        }}
      />

      <FinishModalContainer
        modalTitle={!activeUser ? userDeactivateStatesList.title : userActiveStatesList.title}
        modalMessage={!activeUser ? userDeactivateStatesList.finish : userActiveStatesList.finish}
        modalState={finishModalState}
        finishHandler={handelCloseModals}
      />

      <LoaderWithErrorHandler store={users} resetAlertHandler={customerAdminResetAlertHandler}/>
    </>
  )
}

const styles = {
  goBackWrapper: {
    '&.MuiGrid-root': {
      paddingTop: { xs: '20px', sm: '0px' },
    },
  },
  usersWrapper: {
    display: 'flex',
    alignItems: { xs: 'flex-start', sm: 'center' },
    flexWrap: 'wrap',
    flexDirection: { xs: 'column', sm: 'row' },
    '&.MuiGrid-root': {
      paddingTop: { xs: '0px', sm: 'unset' },
    },

  },
  usersSection: {
    margin: { xs: '0px 0px 10px 0px', sm: 0 },
  },
  usersTitle: {
    color: '#171725',
    lineHeight: 1.36,
    letterSpacing: 0.1,
    fontSize: { xs: '20px', sm: '24px' },
    fontWeight: { xs: 500, sm: 900 },
  },
  actionButtonsContainer: {
    display: 'flex',
    width: '100%',
    marginTop: { xs: 0, sm: '-50px' },
    float: 'right',
    justifyContent: { xs: 'space-between', sm: 'flex-end' },
    gap: { xs: '10px', sm: '20px' },
  },
  btnContainer: {
    display: 'flex',
    justifyContent: { xs: 'space-between', sm: 'flex-end' },
  },
  ButtonsContainer: {
    height: { xs: '30px', sm: '40px' },
    minWidth: { xs: '80px', sm: '150px' },
  },
  infoTabsTitle: {
    fontFamily: 'Avenir',
    fontSize: { xs: '12px', sm: '14px' },
    color: '#000000',
    fontWeight: '500',
    cursor: 'pointer',
    display: 'block',
  },
  activeStep: {
    height: { xs: '3px', sm: '5px' },
    borderRadius: '2px',
    width: '99%',
    backgroundColor: '#29cc8b',
    marginTop: { xs: '5px', sm: '12px' },
    cursor: 'pointer',
  },
  dataContainer: {
    paddingLeft: { xs: '0', sm: 'unset' },
    marginBottom: { xs: '20px', sm: 'unset' },
  },
  activeStepBody: {
    paddingTop: { xs: '20px', sm: '3%' },
    width: '100%',
    marginBottom: '20px',
  },
  step: {
    height: { xs: '3px', sm: '5px' },
    borderRadius: '2px',
    width: '99%',
    backgroundColor: '#eaebf1',
    marginTop: { xs: '5px', sm: '12px' },
    cursor: 'pointer',
  },
  activeBtnContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
  },
  inactive: {
    color: '#92929d',
    fontSize: { xs: '12px', sm: 'unset' },
  },
  active: {
    color: '#29cc8b',
    fontSize: { xs: '12px', sm: 'unset' },
  },
  iosSwitch: {
    '&.MuiSwitch-root': {
      margin: { xs: '0 8px', sm: 'unset' },
    },
  },
}

export default Index
